<template>
  <div class="card-header px-0 py-3" role="tab">
    <a data-toggle="collapse" data-parent="#ltt-accordion" :href="'#' + href" aria-expanded="true"
       :aria-controls="href">
      <h4 class="m-0 text-white d-flex justify-content-between">
        <slot></slot>
        <i class="fas fa-chevron-down rotate-icon text-primary"></i>
      </h4>
    </a>
  </div>
</template>
<script>
export default {
  name: 'CardHeader',
  props: {
      href: {
          type: String,
          required: true
      }
  }
}
</script>
